<div class="inner-container">
  <p>Tenant Users Page</p>
  <div style="margin: 10px; align-self: center;">
    <button mat-flat-button color="accent" (click)="handleGetTenantUsers()">Get Tenant Users</button>
  </div>
</div>